import React from 'react';
import './youTubeVideo.scss';

interface YouTubeVideoProps {
    url: string;
}

export default function YouTubeVideo({ url }: YouTubeVideoProps) {
    // Extrae el ID del video del enlace tipo "https://youtu.be/WTsinsfY6dk"
    const videoId = url.split('/').pop();

    return (
        <div className="video-container">
            <iframe
                className='video'
                width="560"
                height="315"
                src={`https://www.youtube.com/embed/${videoId}`}
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
            ></iframe>
        </div>
    );
}
